import React from 'react';

const JS_HTML_Input = () => {
  return (
    <div >
      <h1>JS_HTML_Input</h1>
      <p>Placeholder component for: "JS HTML Input"</p>
    </div>
  );
};

export default JS_HTML_Input;
